import { makeStyles } from '@material-ui/core'

// Custom styles
export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    marginBottom: 30,
    marginTop: 20,
    borderRadius: 4
  },
  row: {
    marginBottom: theme.spacing(2)
  },
  label: {
    fontWeight: 'bold',
    color: theme.palette.grey[500]
  },
  value: {
    color: theme.palette.text.primary
  }
}))
